import React, { FC, useState } from 'react';
import { Button, Col, Descriptions, Input, Modal, Row, Spin, Typography } from 'antd';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';

import { useRecoveryAccountContext } from './context';
import IAPInfoModal from './iap-modal';

const { Text, Title } = Typography;

function convertTypeToLabel(type: string) {
  switch (type) {
    case 'portal':
      return 'Portal Account';
    case 'portal_email':
      return 'Portal Email';
    case 'ai':
      return 'Apple';
    case 'st':
      return 'Steam';
    case 'ga':
      return 'Google';

    default:
      return type;
  }
}

const FindByUserId: FC = () => {
  const {
    environment,
    userId,
    setUserId,
    recoveryPlayerInfo,
    recoveryEmail,
    recoveryEmailIAPInfo,
    isFetchingByUserId,
    handleGetRecoveryEmail,
  } = useRecoveryAccountContext();
  const [iapInfoModalVisible, setIapInfoModalVisible] = useState(false);

  return (
    <>
      <Title level={5} className="mr-2">
        User ID
      </Title>
      <Row gutter={[16, 16]} className="mb-4">
        <Col>
          <Input.Group>
            <Input
              value={userId}
              placeholder="Enter user ID"
              style={{ width: 250 }}
              onChange={(e) => setUserId(e.target.value)}
              onPressEnter={handleGetRecoveryEmail}
            />
            <Button
              htmlType="submit"
              type="primary"
              onClick={handleGetRecoveryEmail}
              disabled={!userId || !environment}
            >
              <SearchOutlined />
            </Button>
          </Input.Group>
        </Col>
        {recoveryPlayerInfo && (
          <Descriptions bordered size="default" layout="horizontal" column={1} className="w-full">
            <Descriptions.Item label="User ID">
              <Text copyable={{ text: recoveryPlayerInfo.Id }}>{recoveryPlayerInfo.Id}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Name">{recoveryPlayerInfo.Name}</Descriptions.Item>
            <Descriptions.Item label="Clan ID">
              {recoveryPlayerInfo.Clan_Id ?? '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Clan Name">
              {recoveryPlayerInfo.ClanName ?? '-'}
            </Descriptions.Item>
            {recoveryEmail.map((item) => (
              <>
                <Descriptions.Item key={item.type} label={convertTypeToLabel(item.type)}>
                  <Text copyable={!!item.account && { text: item.account }}>{item.account}</Text>
                </Descriptions.Item>
                {item.email && (
                  <Descriptions.Item
                    key={`${item.type}_email`}
                    label={convertTypeToLabel('portal_email')}
                  >
                    <Text copyable={!!item.email && { text: item.email }}>{item.email}</Text>
                  </Descriptions.Item>
                )}
              </>
            ))}
          </Descriptions>
        )}
        {recoveryPlayerInfo && (
          <Button type="link" onClick={() => setIapInfoModalVisible(true)}>
            {recoveryEmailIAPInfo.length} IAP Transactions
          </Button>
        )}
      </Row>
      <IAPInfoModal
        data={recoveryEmailIAPInfo}
        visible={iapInfoModalVisible}
        onOk={() => setIapInfoModalVisible(false)}
        onCancel={() => setIapInfoModalVisible(false)}
      />
      <Modal visible={isFetchingByUserId} closable={false} footer={null}>
        <div className="flex justify-center">
          <Spin indicator={<LoadingOutlined spin />} tip="Fetching by user ID..." />
        </div>
      </Modal>
    </>
  );
};

export default FindByUserId;
